import { Box, Typography } from '@mui/material';

import {
  AccountDetails,
  AccountPreferences,
  PlanInfo,
  UserInfo,
} from './components';
import { ConfirmRecoveryEmail } from './components/ConfirmRecoveryEmail';

export const Profile = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          maxWidth: 670,
          width: '100%',
        }}>
        <Typography variant="h1">Profile</Typography>
        <ConfirmRecoveryEmail />
        <Box sx={{ mt: 6 }}>
          <UserInfo />
        </Box>
        <Box sx={{ mt: 3.5 }}>
          <PlanInfo />
        </Box>
        <Box sx={{ mt: 6 }}>
          <AccountPreferences />
        </Box>
        <Box sx={{ mt: 6 }}>
          <AccountDetails />
        </Box>
      </Box>
    </Box>
  );
};
